export const truncateText = (text, limit) => {
    return text && (text.length <= limit ? text : `${text.slice(0, limit)}...`);
};